import React from "react";

const HowItWorks = () => {
  return (
    <div
      className="section-full p-t150 site-bg-white twm-w-steps-section-wrap wow fadeInDown"
      style={{ backgroundImage: "url(images/step-bg.jpg)" }}
    >
      <div className="container">

        {/* TITLE */}
        <div className="section-head center">
          <div className="twm-sm-title left">Shivai Travels Process</div>
          <h2 className="twm-large-title site-text-dark">
            Easy Steps To Book Your Ride
          </h2>
        </div>

        {/* STEPS */}
        <div className="section-content">
          <div className="row twm-w-steps-section">

            {/* Step 1 */}
            <div className="col-lg-3 col-md-6 m-b30">
              <div className="twm-w-steps">
                <div className="twm-w-step-count">
                  <span>01</span>
                </div>

                <div className="twm-w-step-detail">
                  <h3 className="twm-title">Choose Your Vehicle</h3>

                  <p>
                    Select from our wide range of sedans, SUVs, Innova,
                    Tempo Travellers, and luxury vehicles for your trip.
                  </p>
                </div>
              </div>
            </div>

            {/* Step 2 */}
            <div className="col-lg-3 col-md-6 m-b30">
              <div className="twm-w-steps">
                <div className="twm-w-step-count">
                  <span>02</span>
                </div>

                <div className="twm-w-step-detail">
                  <h3 className="twm-title">Share Trip Details</h3>

                  <p>
                    Provide your pickup location, travel date, destination,
                    and preferred travel package for quick booking.
                  </p>
                </div>
              </div>
            </div>

            {/* Step 3 */}
            <div className="col-lg-3 col-md-6 m-b30">
              <div className="twm-w-steps">
                <div className="twm-w-step-count">
                  <span>03</span>
                </div>

                <div className="twm-w-step-detail">
                  <h3 className="twm-title">Confirm Booking</h3>

                  <p>
                    Get instant fare details and confirm your cab booking
                    with Shivai Travels at affordable prices.
                  </p>
                </div>
              </div>
            </div>

            {/* Step 4 */}
            <div className="col-lg-3 col-md-6 m-b30">
              <div className="twm-w-steps">
                <div className="twm-w-step-count">
                  <span>04</span>
                </div>

                <div className="twm-w-step-detail">
                  <h3 className="twm-title">Enjoy Your Journey</h3>

                  <p>
                    Sit back and enjoy a safe, comfortable, and hassle-free
                    ride with our professional drivers.
                  </p>
                </div>
              </div>
            </div>

          </div>

          {/* IMAGE */}
        

        </div>

      </div>
    </div>
  );
};

export default HowItWorks;